import { type Cohort } from 'Cohorts';
import { type UserIdVerification } from './UserIdVerification.types';

export function forVerificationPeriod(userIdVerification: UserIdVerification, cohort: Cohort, index: number) {
    return userIdVerification.cohortId === cohort.id && userIdVerification.idVerificationPeriodIndex === index;
}
